var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3427 9.35419C21.8069 11.6322 21.476 14.0005 20.4054 16.0641C19.3348 18.1278 17.5891 19.762 15.4594 20.6943C13.3297 21.6266 10.9447 21.8006 8.70223 21.1873C6.45976 20.574 4.49531 19.2105 3.1365 17.3241C1.77768 15.4377 1.10662 13.1425 1.23524 10.8212C1.36385 8.49996 2.28436 6.29294 3.84326 4.56822C5.40216 2.8435 7.50522 1.70533 9.80172 1.34352C12.0982 0.981714 14.4493 1.41813 16.463 2.58M8.33236 10.3701L11.3815 13.4192L21.5453 3.25541",
    stroke: "#10B981",
    strokeWidth: 2.43932,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted1);
export default __webpack_public_path__ + "static/media/completed1.369a3dde3bd3cbf727492bc9f816adf2.svg";
export { ForwardRef as ReactComponent };